import { render, staticRenderFns } from "./CheckoutDetail.vue?vue&type=template&id=00975c7d&scoped=true"
import script from "./CheckoutDetail.vue?vue&type=script&lang=js"
export * from "./CheckoutDetail.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDetail.vue?vue&type=style&index=0&id=00975c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00975c7d",
  null
  
)

export default component.exports